Object.defineProperty(exports, "__esModule", { value: true });
exports.themes = void 0;
var themes_1 = require("./themes");
var themes_2 = require("./themes");
Object.defineProperty(exports, "themes", { enumerable: true, get: function () { return themes_2.themes; } });
exports.default = themes_1.themes;
//# sourceMappingURL=index.js.map